import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-accounts-management',
  templateUrl: './accounts-management.component.html',
  styleUrls: ['./accounts-management.component.css']
})
export class AccountsManagementComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns = ['emailAddress', 'primaryMobileNumber', 'address','companyName', 'companySize', 'accountStatus','status','dateOfCreation','action']
  dataSource: any;
  tableData: any;
  userDetails: any;
  userSessionData: any;
  showFilter:boolean=false
  showCustomisedSearch:boolean=false
  searchValue:any;
  filterValueSelected:any;
  constructor(private cs: CucurachaAdminService,private excelService: ExcelService) { }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'userAccountmanagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
      console.log(this.tableData)
      this.excelService.exportAsExcelFile(this.tableData, 'Accounts');
      this.cs.exportLogAdd(this.userDetails.emailId, 'Accounts').subscribe((data) => {
      })
  }
  deleteAccount(id:any){
    this.cs.deleteAccounts(id).subscribe((data)=>{
      this.getallaccounts()
    })

  }
  ngOnInit(): void {
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
     
    })
    this.cs.getallaccounts().subscribe((data)=>{
      this.dataSource = new MatTableDataSource(data.result)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator


    })
  }
  getallaccounts(){
    this.cs.getallaccounts().subscribe((data)=>{
      this.dataSource = new MatTableDataSource(data.result)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator


    })
  }
  filter() {
    this.getallaccounts()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForAccounts(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getallaccounts()
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getallaccounts();

  }
}
